import React, {useRef, useState} from 'react';
import {TrashSelectionStep} from "./Steps/TrashSelectionStep";
import {PickUpStep} from "./Steps/PickUpStep";
import {DeliveryInformationStep} from "./Steps/DeliveryInformationStep";
import {ContactFormStep} from "./Steps/ContactFormStep";
import {StepsBar} from "./Steps/Helper/StepsBar";
import {FinalStep} from "./Steps/FinalStep";
import {Loader} from "./Steps/Helper/Loader";

const App = () => {
    const [step, setStep] = useState(1);
    const [manualSelection, setManualSelection] = useState(false);
    const [manualTrashType, setManualTrashType] = useState();
    const [manualTrashSize, setManualTrashSize] = useState();
    const [manualTrashPrice, setManualTrashPrice] = useState('');
    const [floor, setFloor] = useState(0);
    const [trashNearHouse, setTrashNearHouse] = useState(false);
    const [elevatorExist, setElevatorExist] = useState(false);
    const [address, setAddress] = useState('');
    const [deliveryDate, setDeliveryDate] = useState('');
    const [deliveryTime, setDeliveryTime] = useState(0);
    const [deliveryTimeLabel, setDeliveryTimeLabel] = useState('');
    const [notes, setNotes] = useState('');
    const [isCompany, setIsCompany] = useState(false);
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [companyCode, setCompanyCode] = useState('');
    const [taxCode, setTaxCode] = useState('');
    const [trashesPhotos, setTrashesPhotos] = useState([]);
    const [uploadedPhotos, setUploadedPhotos] = useState([]);
    const [trashStacksCount, setTrashStacksCount] = useState(1);
    const [maxTrashStacksCount, setMaxTrashStacksCount] = useState(2);
    const [tags, setTags] = useState([]);
    const [selectedSize, setSelectedSize] = useState('');
    const [apiUrl, setApiUrl] = useState(window.apiData.apiUrl);
    const [showLoader, setShowLoader] = useState('hide');
    const [extraInformationAboutTrashes, setExtraInformationAboutTrashes] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    const [bagsCount, setBagsCount] = useState(0);
    const stepsBarRef = useRef(null);

    return (
        <>
            <div id="form-body">
                <StepsBar step={step} stepsBarRef={stepsBarRef}/>
                {step === 1 && <TrashSelectionStep setStep={setStep} manualSelection={manualSelection}
                                                   setManualSelection={setManualSelection}
                                                   manualTrashType={manualTrashType}
                                                   setManualTrashType={setManualTrashType}
                                                   manualTrashSize={manualTrashSize}
                                                   setManualTrashSize={setManualTrashSize}
                                                   manualTrashPrice={manualTrashPrice}
                                                   setManualTrashPrice={setManualTrashPrice}
                                                   trashesPhotos={trashesPhotos}
                                                   setTrashesPhotos={setTrashesPhotos}
                                                   trashStacksCount={trashStacksCount}
                                                   setTrashStacksCount={setTrashStacksCount}
                                                   maxTrashStacksCount={maxTrashStacksCount}
                                                   tags={tags} setTags={setTags} selectedSize={selectedSize}
                                                   setSelectedSize={setSelectedSize}
                                                   apiUrl={apiUrl}
                                                   setUploadedPhotos={setUploadedPhotos}
                                                   setShowLoader={setShowLoader}
                                                   showLoader={showLoader}
                                                   setExtraInformationAboutTrashes={setExtraInformationAboutTrashes}
                                                   selectedCity={selectedCity}
                                                   setSelectedCity={setSelectedCity}
                                                   setBagsCount={setBagsCount}
                                                   stepsBarRef={stepsBarRef}
                />}
                {step === 2 &&
                    <PickUpStep setStep={setStep} floor={floor} setFloor={setFloor} trashNearHouse={trashNearHouse}
                                setTrashNearHouse={setTrashNearHouse} elevatorExist={elevatorExist}
                                setElevatorExist={setElevatorExist} apiUrl={apiUrl} stepsBarRef={stepsBarRef}
                                deliveryDate={deliveryDate} selectedCity={selectedCity}
                                selectedSize={selectedSize} bagsCount={bagsCount}/>}
                {step === 3 && <DeliveryInformationStep setStep={setStep} address={address} setAddress={setAddress}
                                                        deliveryDate={deliveryDate} setDeliveryDate={setDeliveryDate}
                                                        deliveryTime={deliveryTime} setDeliveryTime={setDeliveryTime}
                                                        notes={notes} setNotes={setNotes}
                                                        setDeliveryTimeLabel={setDeliveryTimeLabel}
                                                        apiUrl={apiUrl} stepsBarRef={stepsBarRef}
                                                        selectedCity={selectedCity} selectedSize={selectedSize}
                                                        floor={floor} bagsCount={bagsCount}
                                                        elevatorExist={elevatorExist} trashNearHouse={trashNearHouse}
                />}
                {step === 4 &&
                    <ContactFormStep setStep={setStep} isCompany={isCompany} setIsCompany={setIsCompany} name={name}
                                     setName={setName} phone={phone} setPhone={setPhone} email={email}
                                     setEmail={setEmail} companyName={companyName} setCompanyName={setCompanyName}
                                     companyCode={companyCode} setCompanyCode={setCompanyCode} taxCode={taxCode}
                                     setTaxCode={setTaxCode} deliveryDate={deliveryDate} elevatorExist={elevatorExist}
                                     deliveryTime={deliveryTime} notes={notes} trashNearHouse={trashNearHouse}
                                     address={address}
                                     selectedCity={selectedCity}
                                     selectedSize={selectedSize}
                                     floor={floor} deliveryTimeLabel={deliveryTimeLabel}
                                     bagsCount={bagsCount}
                                     infoAboutBags={extraInformationAboutTrashes}
                                     apiUrl={apiUrl}
                                     trashesPhotos={uploadedPhotos}
                                     trashStacksCount={trashStacksCount}
                                     tags={tags}
                                     stepsBarRef={stepsBarRef}
                    />}
                {step === 5 &&
                    <FinalStep/>}

            </div>
            <Loader showLoader={showLoader}/>
        </>
    )
};

export default App;
